$(function () {
  $(document).on(oEventNames.end, '.js-tell-btn',function(e){
    if (!bIsScrolling) {
      //伝播をストップ
      e.stopPropagation();
      e.preventDefault();

      //リンクを取得して飛ばす
      location.href = $(this).attr('data-href');
    }
  });
  $(document).on(oEventNames.end, '.js-company-site',function(e){
    if (!bIsScrolling) {
      //伝播をストップ
      e.stopPropagation();
      e.preventDefault();

      //リンクを取得して飛ばす
      const url = $(this).attr('data-href');
      window.open(url, '_blank', "noreferrer")
    }
  });
});
